import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const toggleStackletRecoveryMode = (
  id: number,
  data: { action: string },
): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data,
  });
